<template>
  <div class="qr-code-container">
    <p class="text-center qr-info" style="font-weight: bold; font-size: 20px" v-if="text">
      {{ text }}{{ integratedMethod === 'VAMC' && ' - MC' }}
    </p>
    <div ref="qrCodeModalContainer" class="text-center">
      <QRCodeStyling
        :logo="logo"
        :data="qrCode"
        :size="qrSize"
        :imageOptions="{
          crossOrigin: 'anonymous',
          margin: 3,
          imageSize: 0.6,
          hideBackgroundDots: true,
        }"
      />
    </div>

    <div class="">
      <div v-if="bankUser" class="text-center qr-info">
        <span class="qr-code-text" style="font-weight: bold; font-size: 20px">{{ bankUser }} </span>
      </div>
      <div v-if="bank" class="text-center qr-info">
        <span class="qr-code-text" style="font-weight: bold; font-size: 20px">{{ bank }}</span>
      </div>
      <div v-if="qrId" class="text-center qr-info"><strong>QR ID:</strong> {{ qrId }}</div>
      <div v-if="qrCode && !bank" class="text-center qr-info">
        <strong>QR Code:</strong> <span class="qr-code-text">{{ qrCode }}</span>
      </div>
    </div>
  </div>
</template>
<style scoped>
  .qr-code-container {
    /* display: flex; */
    align-items: center;
    justify-content: center;
  }

  .qr-info {
    font-size: 0.85rem;
    /* Điều chỉnh kích thước font cho nhỏ lại */
  }

  .qr-code-text {
    word-break: break-all;
    /* Ngắt chuỗi ở bất kỳ ký tự nào để tránh tràn */
    overflow-wrap: break-word;
    /* Tự động wrap chuỗi dài thành nhiều dòng */
    max-width: 100%;
    /* Giới hạn chiều rộng của chuỗi không vượt quá modal */
    white-space: normal;
    /* Cho phép chuỗi được ngắt dòng */
    text-align: left;
    /* Canh trái để dễ đọc (nếu cần) */
    margin: 0.25rem 0;
  }
</style>
<script>
  import QRCodeStyling from './../qrCodeStyling.vue'

  export default {
    components: {
      QRCodeStyling,
    },
    props: {
      qrCode: {
        type: String,
        required: false,
      },
      bankUser: {
        type: String,
        required: false,
      },
      integratedMethod: {
        type: String,
        required: false,
      },
      bank: {
        type: String,
        required: false,
      },
      text: {
        type: String,
        required: false,
      },
      qrId: {
        type: String,
        required: false,
      },
      logo: {
        type: String,
        required: true,
      },
      qrSize: {
        type: Number,
        required: true,
      },
    },
  }
</script>
